import React from 'react';
import cn from 'classnames';
import Tooltip from '@dealroadshow/uikit-tooltip';
import styles from './stepsProgress.module.scss';
import CheckCellCallback from '@framework/ui/Molecules/Tables/CellCallbacks/CheckCellCallback';

const STEPS = [
  {
    id: 'disclaimerConfirmed',
    title: 'Confirm the disclaimer',
  },
  {
    id: 'invitationEmailConfirmed',
    title: 'Confirm the investor email invitation',
  },
  {
    id: 'companyDetails',
    title: 'Add Bank details to Enhanced Tagging',
  },
  {
    id: 'addInvestors',
    title: 'Add investors',
  },
  {
    id: 'uploadResearch',
    title: 'Upload research',
  },
];

const StepsProgress = ({ stage }: { stage?: { steps?: Record<string, boolean> } }) => {
  const steps = stage?.steps || {};
  const passedStepsCount = Object.values(steps)
    .filter((value) => !!value).length;

  const tooltipContent = (
    <div className={ styles.tooltipContainer }>
      <div className={ styles.tooltipStepsWrp }>
        { STEPS.map(({
          id,
          title,
        }) => (
          <div key={ id } className={ styles.tooltipStep }>
            <CheckCellCallback cellData={ !!steps[id] } className={ styles.checkbox } />
            <div className={ styles.text }>{ title }</div>
          </div>
        )) }
      </div>
    </div>
  );

  return (
    <Tooltip
      content={ tooltipContent }
      maxWidth={ 350 }
    >
      <div className={ cn(styles.stepsWrp, {
        [styles.completed]: passedStepsCount === STEPS.length,
        [styles.partlyCompleted]: passedStepsCount <= 4,
        [styles.lowCompleted]: passedStepsCount < 3,
      }) }
      >
        { STEPS.map(({ id }, idx) => (
          <div key={ id } className={ cn(styles.step, { [styles.passed]: idx < passedStepsCount }) }>
            <div className={ styles.stepLine } />
          </div>
        )) }
      </div>
    </Tooltip>
  );
};

export default StepsProgress;
